export const DETAIL_FILE_SOURCE_TYPE_STATIC = 'static'
export const DETAIL_FILE_SOURCE_TYPE_COMPONENT_EXPORT = 'component_export'

export const DETAIL_FILE_COMPONENT_EXPORT_ANNOTATION = 'comp_ann'

const DETAIL_TEXT_SOURCE_LABEL_MAP = Object.freeze({
  step1: '初核问题',
  novelty: '新颖性问题',
  creativity: '创造性问题',
  completeness: '充分公开问题',
  'strategic-alignment': '战略匹配问题',
  'invent-idea': '发明构思',
  'detail-list': '交流清单',
})

const removeFileExtension = (fileName = '') => {
  return String(fileName || '').replace(/\.[^.]+$/, '')
}

const trimString = (value = '') => String(value || '').trim()

const stripLeadingQuestionPrefix = (question = '') => {
  return trimString(question).replace(/^(?:\[[^\]]+\]|【[^】]+】)\s*/, '')
}

export const buildAnnotationDetailListFileItem = (application = {}) => {
  const sourceFileId = application?.modelUploadId || application?.filePath || application?.fileName || 'annotation'
  const sourceFileName = application?.fileName || '原文批注.docx'
  const baseName = removeFileExtension(sourceFileName) || '原文批注'

  return {
    type: 'file',
    sourceType: DETAIL_FILE_SOURCE_TYPE_COMPONENT_EXPORT,
    componentTypeCode: DETAIL_FILE_COMPONENT_EXPORT_ANNOTATION,
    sourceFileId,
    sourceId: `${DETAIL_FILE_SOURCE_TYPE_COMPONENT_EXPORT}:${DETAIL_FILE_COMPONENT_EXPORT_ANNOTATION}:${sourceFileId}`,
    fileName: `${baseName}-批注.docx`,
  }
}

export const isAnnotationComponentExportItem = (item = {}) => {
  return item?.type === 'file'
    && item?.sourceType === DETAIL_FILE_SOURCE_TYPE_COMPONENT_EXPORT
    && item?.componentTypeCode === DETAIL_FILE_COMPONENT_EXPORT_ANNOTATION
}

export const getDetailListSourceKey = (item = {}) => {
  if (!item || typeof item !== 'object') {
    return ''
  }

  if (item.sourceKey) {
    return String(item.sourceKey)
  }

  const sourceId = String(item.sourceId || '')
  if (sourceId.startsWith('step1:')) {
    return 'step1'
  }
  if (sourceId.startsWith('novelty:')) {
    return 'novelty'
  }
  if (sourceId.startsWith('creativity:')) {
    return 'creativity'
  }
  if (sourceId.startsWith('completeness:')) {
    return 'completeness'
  }
  if (sourceId.startsWith('strategic-alignment:')) {
    return 'strategic-alignment'
  }
  if (sourceId.startsWith('invent-idea:')) {
    return 'invent-idea'
  }
  if (sourceId.startsWith('detail-list:')) {
    return 'detail-list'
  }
  return ''
}

export const getDetailListSourceLabel = (item = {}) => {
  return DETAIL_TEXT_SOURCE_LABEL_MAP[getDetailListSourceKey(item)] || ''
}

export const buildDetailListQuestion = (question = '', sourceKey = '') => {
  const normalizedQuestion = stripLeadingQuestionPrefix(question)
  const sourceLabel = DETAIL_TEXT_SOURCE_LABEL_MAP[sourceKey] || ''

  if (!sourceLabel) {
    return trimString(question)
  }

  return normalizedQuestion ? `[${sourceLabel}]${normalizedQuestion}` : `[${sourceLabel}]`
}

export const getDetailListDisplayQuestion = (item = {}) => {
  if (!item || item.type === 'file') {
    return ''
  }

  return buildDetailListQuestion(item.question, getDetailListSourceKey(item))
}

export const normalizeDetailListItem = (item = {}) => {
  if (!item || typeof item !== 'object' || item.type === 'file') {
    return item
  }

  const sourceKey = getDetailListSourceKey(item)
  return {
    ...item,
    ...(sourceKey ? { sourceKey } : {}),
    question: buildDetailListQuestion(item.question, sourceKey),
  }
}

export const normalizeDetailListItems = (list = []) => {
  if (!Array.isArray(list)) {
    return []
  }

  return list.map(normalizeDetailListItem)
}

export const getDetailListItemKey = (item = {}) => {
  if (!item || typeof item !== 'object') {
    return ''
  }

  if (item.type === 'file') {
    if (item.sourceId) {
      return String(item.sourceId)
    }

    return [
      'file',
      item.sourceType || DETAIL_FILE_SOURCE_TYPE_STATIC,
      item.componentTypeCode || '',
      item.sourceFileId || item.filePath || item.fileUrl || item.fileName || '',
    ].join(':')
  }

  return String(item.sourceId || `${item.type || 'text'}:${item.question || ''}:${item.answer || ''}`)
}
